import { cn } from "../../lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";

export interface Shop {
  id: string;
  name: string;
  logoUrl?: string;
  isActive?: boolean | null;
  /** Shown under the name when set: super admin search results, several shops sharing a name. */
  shopifyUrl?: string | null;
}

type ShopLogoProps = {
  shop: Shop;
};

export function ShopLogo({ shop }: ShopLogoProps) {
  return (
    <div className="relative">
      <Avatar className={cn("border rounded-full w-6 h-6 md:w-8 md:h-8")}>
        <AvatarImage src={shop.logoUrl} />
        <AvatarFallback>{shop?.name?.charAt(0).toUpperCase()}</AvatarFallback>
      </Avatar>
    </div>
  );
}
